const AVATAR_FALLBACK_COLOR: string = "#0404cb"

export { AVATAR_FALLBACK_COLOR }
